// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

export function fetchImportLogEvents(query) {
  return { type: types.IMPORT_EVENT_LOGS_FETCH_BEGIN, query }
}
